import React from 'react';

import MetricBox from './MetricBox';

interface DistanceFromHomeProps {
  meters: number;
}

const format = (meters: number): string => {
  const km = (meters / 1000).toFixed(2);
  return `${km} km`;
};

const DistanceFromHome: React.FC<DistanceFromHomeProps> = ({ meters }) => (
  <MetricBox label='Distance from Home' value={format(meters)} />
);

export default DistanceFromHome;
